
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Chip, CircularProgress, Collapse, Container, Dialog, DialogActions, DialogTitle, Divider, Grid, IconButton, makeStyles, Paper, Tooltip, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import { green, grey, red } from '@material-ui/core/colors';
import { getUserWordBank, removeIgnoredWord } from '../../actions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import InfoIcon from '@material-ui/icons/Info';
import TableMdUpScreen from '../TableComponents/TableMdUpScreen';

const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',

    }, greenText: {
        color: green[600]
    }, redText: {
        color: red[500]
    }, title: {
        margin: '20px 0px 60px'
    }, centerTopPaper: {
        margin: '20px 0px',
        padding: '10px 0px'
    }, userInformationText: {
        margin: '0px 35px 5px'
    }, box: {
        padding: "15px 15px",
        margin: '0px 0px 20px'
    }, userTitleFormat: {
        margin: '10px 0px',
    }, ignoredWordPaper: {
        margin: '10px 10px',
        padding: '10px 10px'
    }, ignoredWordTitle: {
        margin: '0px 0px 20px',
        padding: '10px'
    }, wordPaper: {
        margin: '10px 10px',
        background: grey[700]
    }, emptyIgnoredWordsList: {
        padding: '10px'
    }, infoIcon: {
        color: grey[300],
        transform: 'scale(.8)',
        margin: '0px 2px 2px'
    }

}));

const userItemsToRender =
    [
        {
            title: 'User Name:',
            field: 'userName'
        },
        {
            title: 'First Name:',
            field: 'firstName'
        },
        {
            title: 'Last Name:',
            field: 'lastName'
        },
        {
            title: 'Email:',
            field: 'email'
        }

    ]




const Portfolio = () => {
    const user = useSelector(state => state.auth.user)
    const classes = useStyles();
    const theme = useTheme();
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("md"));
    const userWordBank = useSelector(state => state.userWordBank);
    const dispatch = useDispatch();
    const [loadedOnce, setLoadedOnce] = useState(true);
    const [isIgnoreWordExpanded, setIsIgnoreWordExpanded] = useState(false);
    const [isShowingWordBank, setIsShowingWordBank] = useState(false);
    const [areYouSureOpen, setAreYouSureOpen] = useState(false);
    const [wordSureAbout, setWordSureAbout] = useState('');

    const handleAreYouSureOpen = (word) => {
        setWordSureAbout(word);
        setAreYouSureOpen(true);
    }
    const handleAreYouSureClose = (word) => {
        setAreYouSureOpen(false);
        if (!word || word.length === 0) {
            return;
        }
        dispatch(removeIgnoredWord(word));
    }



    if (loadedOnce) {
        dispatch(getUserWordBank());
        setLoadedOnce(false);
    }

    const renderIgnoredWordsList = (wordList) => {
        if (wordList === null) {
            return <CircularProgress />
        }
        if (wordList.length === 0) {
            return (
                <Grid key='000' item className={classes.emptyIgnoredWordsList}>
                    You currently have no words that you are ignoring.
                </Grid>
            )
        }

        return (wordList.map((element) => {
            return (
                <Grid key={element} item  >
                    <Chip className={classes.ignoredWordPaper} label={element} onDelete={() => handleAreYouSureOpen(element)} />
                </Grid>
            )

        })
        )
    }


    return (
        <Container className={classes.root}>
            <Grid justify="space-between" container>
                <Grid item xs={12}>
                    <Paper className={classes.centerTopPaper}>
                        <Grid container >
                            <Grid item xs={12}>
                                <Typography variant='h4'>
                                    Word Money
                                </Typography>
                                <Typography variant='h1'>
                                    ${user.wordMoney}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography color='textSecondary' variant='body2'>
                                    Total Losses
                                </Typography>
                                <Typography className={classes.redText} variant="h5">
                                    {user.lifeTimeLosses} $
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography color='textSecondary' variant='body2'>
                                    Words Learned
                                </Typography>
                                <Typography variant="h5">
                                    {user.wordsLearned}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography color='textSecondary' variant='body2'>
                                    Total Profit
                                </Typography>
                                <Typography className={classes.greenText} variant="h5">
                                    +{user.lifeTimeProfit} $
                                </Typography>
                            </Grid>

                        </Grid>
                    </Paper>
                </Grid>
            </Grid>





            <Grid
                direction={isMdOrUp ? null : "column-reverse"}
                container
                justify="space-between"
                alignItems={isMdOrUp ? "flex-start" : "center"}
            >
                <Grid item md={8} xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Paper className={classes.ignoredWordTitle}>
                                <Grid container justify='center'>
                                    <Grid item sm={11}>
                                        <Typography color='primary' className={classes.userInformationText} variant='h5'>
                                            Ignored Words
                                    <Tooltip title="This is a list of words that will never show up for you to learn. If a word is in this list, you already know what it means and you didn't learn it on this website." >
                                                <InfoIcon className={classes.infoIcon} />
                                            </Tooltip>
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={1}>
                                        <IconButton size='small' onClick={() => setIsIgnoreWordExpanded(!isIgnoreWordExpanded)}>
                                            {isIgnoreWordExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <Collapse in={isIgnoreWordExpanded}>
                                    <Grid container justify='center'>

                                        {renderIgnoredWordsList(userWordBank.ignoredWords)}
                                    </Grid>
                                </Collapse>
                            </Paper>


                        </Grid>

                        <Grid item xs={12}>
                            <Paper className={classes.ignoredWordTitle}>
                                <Grid container justify='center'>
                                    <Grid item sm={11}>
                                        <Typography color='primary' className={classes.userInformationText} variant='h5'>
                                            Word Bank
                                    <Tooltip title="These are all the words you have learned on this website." >
                                                <InfoIcon className={classes.infoIcon} />
                                            </Tooltip>
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={1}>
                                        <IconButton size='small' onClick={() => setIsShowingWordBank(!isShowingWordBank)}>
                                            {isShowingWordBank ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <Collapse in={isShowingWordBank}>
                                    <TableMdUpScreen wordBank={userWordBank.wordBank} />
                                </Collapse>
                            </Paper>

                        </Grid>

                    </Grid>





                </Grid>






                <Grid item md={3} sm={12}>
                    <Paper className={classes.box}>
                        <Grid container justify='center'>
                            <Typography color='primary' className={classes.userInformationText} variant='h5'>User Information</Typography>
                        </Grid>
                        <Divider />


                        {userItemsToRender.map(itemElement => (
                            <Grid key={itemElement.title} className={classes.userTitleFormat} container>
                                <Grid item xs={12}>
                                    <Typography color='textSecondary' align='left' variant='body2'>
                                        {itemElement.title}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography align='right' variant="body2">
                                        {user[itemElement.field]}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}



                    </Paper>
                </Grid>

            </Grid>
            <Dialog open={areYouSureOpen} onClose={handleAreYouSureClose} >
                <DialogTitle>
                    <span style ={{color: 'lightGrey'}}>
                        Are you sure you want to remove <span style={{ color: 'white' }}>{wordSureAbout}</span> from list of ignored words?
                         </span>
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => handleAreYouSureClose()}>
                        <Typography color='error'>No</Typography>
                    </Button>
                    <Button onClick={() => handleAreYouSureClose(wordSureAbout)} color="primary" autoFocus>
                        <Typography>Yes</Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}



export default Portfolio

